"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebChatUpsellToast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const web_popup_1 = require("@snapchat/web-popup");
const ToastBody_1 = __importDefault(require("./ToastBody"));
const react_intl_1 = require("react-intl");
const web_i18n_1 = require("@snapchat/web-i18n");
const messageLoader_1 = require("../../i18n/messageLoader");
/**
 * add this to the top of your page's component tree
 */
function WebChatUpsellToast({ pageType, locale }) {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const handleClose = (0, react_1.useCallback)(() => {
        setIsOpen(false);
    }, []);
    const [messages, setMessages] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        void (0, messageLoader_1.loadMessages)(locale).then((_messages) => {
            setMessages(_messages);
        });
    }, [locale]);
    (0, react_1.useEffect)(() => {
        // show upsell toast on mount
        setIsOpen(true);
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isOpen && ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: (0, jsx_runtime_1.jsx)(web_popup_1.Popup, { children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: "", children: (0, jsx_runtime_1.jsx)(ToastBody_1.default, { closePopup: handleClose, pageType: pageType }) }) }) })) }));
}
exports.WebChatUpsellToast = WebChatUpsellToast;
//# sourceMappingURL=index.js.map